export default "__VITE_PUBLIC_ASSET__c19ee7a6__"